import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as settings from "../../lib/api-constant";
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable, catchError, map, of, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PortalProfileService {

  private readonly PORT_COUNT_KEY = 'portCount';
  private hasFetched = false;

  constructor(protected http: HttpClient) {
  }

  public initializePortCount(): Observable<number> {
    const cachedPortCount = this.getPortCount();
    if (cachedPortCount !== null && this.hasFetched) {
      return of(cachedPortCount); // Return cached value if already fetched
    }

    const url = settings.UserEndPoint.PortalProfile.GET_PORT_CONFIGURATION;
    return this.http.get<any>(url).pipe(
      map((response) => {
        const portCount = response.data.portCount; // Extract portCount
        this.updatePortCount(portCount); // Update BehaviorSubject
        localStorage.setItem(this.PORT_COUNT_KEY, portCount.toString()); // Cache in localStorage
        this.hasFetched = true; // Mark as fetched
        return portCount; // Return only portCount
      }),
      catchError((error) => {
        const fallback = cachedPortCount !== null ? cachedPortCount : 50;
        this.updatePortCount(fallback);
        return of(fallback); // Fallback value
      })
    );
  }

  // Update portCount and localStorage
  public updatePortCount(portCount: number) {
    localStorage.setItem(this.PORT_COUNT_KEY, portCount.toString());
  }

  // Get cached portCount from localStorage
  public getPortCount(): number | null {
    const cached = localStorage.getItem(this.PORT_COUNT_KEY);
    return !cached ? null : parseInt(cached, 10);
  }

  // Reset hasFetched flag (e.g., on logout)
  public resetFetchFlag() {
    this.hasFetched = false;
  }

  public getForcedPortCount(): Observable<number> {
    const url = settings.UserEndPoint.PortalProfile.GET_PORT_CONFIGURATION;
    return this.http.get<any>(url);
  }


  public getKeyReferenceNumber() {
    return new Promise((resolve: any, reject: any) => {
      let url = settings.UserEndPoint.PortalProfile.GET_KEY_REFERENCE_NUMBER;
      this.http.get<any>(url).subscribe((response: any) => {
        resolve(response);
      }, reject);
    });
  }
  public setKeyReferenceNumber(body: any) {
    let url = settings.UserEndPoint.PortalProfile.SET_KEY_REFERENCE_NUMBER;
    return this.http.post(url, body);

  }
  public getSavedFilters() {
    let url = settings.UserEndPoint.PortalProfile.GET_SAVED_FILTERS;
    return this.http.get<any>(url)
  }
  public setSavedFilters(body: any) {
    let url = settings.UserEndPoint.PortalProfile.SET_SAVED_FILTERS;
    return this.http.post(url, body);
  }
  public getUserSavedColumnSequence(type: any) {
    let body = {
      "userColumnSeqJson": "",
      "pageType": type
    }
    let url = settings.UserEndPoint.PortalProfile.GET_USER_SAVED_COLUMN_SEQUENCE;
    return this.http.post(url, body)
  }
  public setUserSavedColumnSequence(type: any, columnSequence: any) {
    let body = {
      "userColumnSeqJson": columnSequence,
      "pageType": type
    }
    let url = settings.UserEndPoint.PortalProfile.SET_USER_SAVED_COLUMN_SEQUENCE;
    return this.http.post(url, body)
  }

  public getStatusConfiguration() {
    let url = settings.UserEndPoint.PortalProfile.GET_STATUS_CONFIGURATION;
    return this.http.get<any>(url)
  }

  public setStatusConfiguration(body: any) {
    let url = settings.UserEndPoint.PortalProfile.SAVE_STATUS_CONFIGURATION;
    return this.http.post(url, body)
  }

  public getPortCountForUser() {
    let url = settings.UserEndPoint.PortalProfile.GET_PORT_CONFIGURATION;
    return this.http.get<any>(url)
  }

  public setPortCountForUser(body: any) {
    let url = settings.UserEndPoint.PortalProfile.SAVE_PORT_CONFIGURATION;
    return this.http.post(url, body)
  }
}

